import { Component, OnInit } from '@angular/core';
import { ApiService, AuthService, CalendarService, ConditionService, DialogService, FieldService, FormulaService, MetadataService, ModalService, SessionService, TranslatorService } from '../../../services';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { DialogComponent } from '../../common/dialog/dialog.component';
import { User } from '../../../models';

@Component({
    selector: 'sn-usc-todays-goal-table',
    templateUrl: './usc-todays-goal-table.component.html',
    styleUrls: ['./usc-todays-goal-table.component.css']
})
export class UscTodaysGoalTableComponent implements OnInit {

    is_daily_goal_loaded: boolean = false;
    is_saving_todays_goal: boolean = false;
    days_remaining: number = 0;
    full_name: string = "";
    is_retail_corp: boolean = false;
    action_plan: any = {};
    public active_user:User;
    business_drivers: any[] = [];
    previous_business_drivers: any[] = [];
    business_drivers_loaded: boolean = false;
    public visibleColumnFields: Array<any> = [];
    private viewConditions: Array<any> = [];
    private viewFormulas: Array<any> = [];
    public columnFields: Array<any> = [];

    constructor(
        public dialogService: DialogService,
        public uscStoreService: UscStoreService,
        public fieldService: FieldService,
        public metaDataService: MetadataService,
        public apiService: ApiService,
        public modalService: ModalService,
        public calendarService: CalendarService,
        public translatorService: TranslatorService,
        public metadataService: MetadataService,
        public conditionService: ConditionService,
        public formulaService: FormulaService,
        public sessionService: SessionService,
        public authService: AuthService,
        ) { }

    ngOnInit() {
        var msgList = ["Please note, you must submit your \"Today's Goals\" before you can proceed into SalesNOW."];				 
        var ngbModalRef = this.modalService.openContent(
            DialogComponent,
            { dlgType: this.dialogService.dlg_type_confirmation, dlg_config: { msgList: msgList }},
            { backdrop: 'static', keyboard: false }
        );
        ngbModalRef.result.then(
            (result) => { ngbModalRef.dismiss(); },
            (reason) => { ngbModalRef.dismiss(); }
        );

        this.active_user = this.authService.getActive();
        this.full_name = this.active_user.first_name + ' ' + this.active_user.last_name;

        this.uscStoreService.getThisMonthActionPlans().subscribe(
            result => {
                this.action_plan = result;
                // this month's action plan has not been approved
                if (this.action_plan == null || this.action_plan.cs_status == this.uscStoreService.action_plan_status_draft) {
                    this.uscStoreService.setCurrentView(this.uscStoreService.view_p2w_this_action_plan);
                } else {
                    this.days_remaining = this.action_plan.cs_days_scheduled - this.action_plan.days_worked;
                }
            }
        );

        this.is_retail_corp = this.uscStoreService.isUSCellCorp();
        this.loadTableViewMetaData();
    }

    loadTableViewMetaData() {
        this.business_drivers_loaded = false;
        this.visibleColumnFields = [];
        this.columnFields = [];
        this.metadataService.getTableViewMetaData(this.uscStoreService.view_p2w_todays_goal_table, {}, true).subscribe(result => {
            this.columnFields = result.meta_data.column_fields;
            this.viewConditions = result.meta_data.view_conditions;
            this.viewFormulas = result.meta_data.view_formulas;
            this.reloadItems();
        });
    }

    reloadItems() {    
        var params = {
            est: 'ST_Search'
        }    
		let dlg = null;
        this.uscStoreService.getData(this.uscStoreService.view_p2w_todays_goal_table, params).subscribe(
            result => {
                this.business_drivers = result.items;
                this.previous_business_drivers = JSON.parse(JSON.stringify(result.items));
                this.processDetailedItems();
            },
            err => {
                console.log(err);
            }
        );
    }

    processDetailedItems() {
        this.is_daily_goal_loaded = true;
        this.business_drivers_loaded = true;
        this.evaluateItemFormulaAndConditions();

        // extract all visible columns
        this.visibleColumnFields = [];
        this.columnFields.forEach(cf => {
            if (cf.visible) {
                var bVisible = true;
                if (cf.sn_column_visible) {
                    var condResult = this.conditionService.getCondition(this.business_drivers[0].viewConditions, cf.sn_column_visible);
                    bVisible = condResult ? condResult.result : true;
                }
                if (bVisible) this.visibleColumnFields.push(cf);
            }
        })
    }
    
    evaluateItemFormulaAndConditions() {
        this.business_drivers.forEach(item => {
            if (this.viewFormulas) {
                var formulas = JSON.parse(JSON.stringify(this.viewFormulas));
                item.viewFormulas = this.formulaService.calculateFormulaValuesByItem(formulas, item);
            }

            if (this.viewConditions) {
                var conditions = JSON.parse(JSON.stringify(this.viewConditions));
                item.viewConditions = this.conditionService.evaluateItemValues(conditions, item.viewFormulas, item);
            }
        });
    }

    getColumnHeader(field): any {
        if (field) {
            var column_label = field.label;
            return column_label;
        }
        return "";
    }

    getFieldValue(item, field): any {
        if (item && field) {
            if (field.sn_calc_formula) {
                var sn_calc_formula = this.translatorService.translate(null, item, field.sn_calc_formula);
                if (sn_calc_formula) {
                    var formula = item.viewFormulas.find(f => f.name == sn_calc_formula);
                    if (formula) return formula.result;
                } 
            }
        
            return item[field.key];            
        }
        return "";
    }

    getFieldValueStyle(item, field) {
        var fvc = {};
        if (item && field) {
            var field_value = item[field.key];
            var bd_conditions = item.viewConditions;
        }
        return fvc;
    }

    isFieldEditable(item, field) {
        if (item && field && field.sn_value_editable) {
            var condition = item.viewConditions.find(c => c.name == field.sn_value_editable);
            if (condition) return condition.result;
        }
        return false;
    }

    isValueVisible(action_plan, field) {
        return true;
    }

    public hasValueTooltip(item, field) {
        return (field && field.sn_value_tooltip && field.sn_value_tooltip.length > 0);
    }

	public getValueTooltip(item, field) {
        var tooltip = "";
        if (this.hasValueTooltip(item, field) && item['tip_' + field.key] == null) {
            item['tip_' + field.key] = this.translatorService.translate(null, item, field.sn_value_tooltip);
        }
        return item['tip_' + field.key];
	}

    onFocusOut(item, field) {
        var bUpdateTodaysGoal = true;
        var previous_driver = this.previous_business_drivers.find(dr => dr.business_driver == item.business_driver);
        if (previous_driver && previous_driver.todays_goals == item.todays_goals) return;

        // evaluate the current item's sn_value_condition first 
        if (item && field && field.sn_value_condition && field.sn_value_condition.length > 0) {
            var formulas = JSON.parse(JSON.stringify(this.viewFormulas));
            item.viewFormulas = this.formulaService.calculateFormulaValuesByItem(formulas, item);
            var conditions = JSON.parse(JSON.stringify(this.viewConditions));
            var cond_results = this.conditionService.evaluateItemValues(conditions, item.viewFormulas, item);
            var condition = cond_results.find(c => c.name == field.sn_value_condition);
            if (condition && condition.result == false) {
                bUpdateTodaysGoal = false;
                var msgList = ["Today's goals must be greater or equal to P2W Daily Goals!"];				 
                var ngbModalRef = this.modalService.openContent(
                    DialogComponent,
                    { dlgType: this.dialogService.dlg_type_confirmation, dlg_config: { msgList: msgList }},
                    { backdrop: 'static', keyboard: false }
                );
                ngbModalRef.result.then(
                    (result) => { ngbModalRef.dismiss(); },
                    (reason) => { ngbModalRef.dismiss(); }
                );
            }
        }

        // if sn_value_condition is valid, save to database, else undo change
        if (bUpdateTodaysGoal) {
            // re-evaluate formula and conditions for all items in case formula dependencies
            this.evaluateItemFormulaAndConditions();
            // update the previous_driver with the new value
            if (previous_driver) previous_driver.todays_goals = item.todays_goals;
            this.updateTodaysGoal();
        } else {  // else, restore the previous value
            if (previous_driver) item.todays_goals = previous_driver.todays_goals;
        }
    }

    updateTodaysGoal() {
        var business_drivers = JSON.parse(JSON.stringify(this.business_drivers));
        business_drivers.forEach(bd => {
            bd.viewConditions = null;
            bd.viewFormulas = null;
        })
        this.uscStoreService.processActionOnViewItemOnPost(this.uscStoreService.view_p2w_action_plan_table, 0, this.uscStoreService.action_update_todays_goal, business_drivers, null).subscribe(
            result => {
                // no need to reload since the new config implemented total calculations
                //this.reloadItems();
            }
        )
    }

    submitGoal() {
        this.is_saving_todays_goal = true;
        var business_drivers = JSON.parse(JSON.stringify(this.business_drivers));
        business_drivers.forEach(bd => {
            bd.viewConditions = null;
            bd.viewFormulas = null;
        })
        this.uscStoreService.processActionOnViewItemOnPost(this.uscStoreService.view_p2w_action_plan_table, 0, this.uscStoreService.action_todays_goal_submission, business_drivers, null).subscribe(
            // this.uscStoreService.processActionOnViewItem(this.uscStoreService.view_p2w_todays_goal_table, 0, this.uscStoreService.action_todays_goal_submission, params).subscribe(
            tgt_result => {
                this.sessionService.log("Today's Goal Submitted");
                this.uscStoreService.getTodaysGoal(true).subscribe(tg_result => {
                    this.uscStoreService.setTodaysGoal(tg_result);
                });
            }
        )
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-todays-goal-table/usc-todays-goal-table.component.ts